import React, { useState, useEffect } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";

interface Circular {
    id: string;
    date?: string;
    title?: string;
    para1?: string;
}

const CircularsContent: React.FC = () => {
    const [circulars, setCirculars] = useState<Circular[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchCirculars = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await serviceApi.get(environment.circulars);
                if (response.status === "SUCCESS" && response.dataList) {
                    setCirculars(response.dataList);
                } else {
                    setError(response.message || "Failed to fetch circulars");
                }
            } catch (err: any) {
                setError(err.message || "An error occurred while fetching circulars");
            } finally {
                setIsLoading(false);
            }
        };
        fetchCirculars();
    }, []);

    return (
        <div className="notification-page">
            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">Loading circulars...</span>
                    </div>
                </div>
            )}
            <h2 className="title-text notification-heading">Circulars</h2>
            {error && <p className="error-text">{error}</p>}
            {!isLoading && !error && circulars.length > 0 &&
                circulars.map((item) => (
                    <div key={item.id} className="event-container">
                        {item.date && (
                            <span
                                className="event-date"
                                style={{
                                    color: "var(--colorPrimaryDark)",
                                    fontWeight: '700',
                                }}
                            >
                                {item.date}
                            </span>
                        )}
                        <div
                            className="horizontal-divider"
                            style={{ margin: "6px 0" }}></div>
                        <div className="event-item">
                            {item.title && (
                                <h4
                                    className="event-title"
                                    style={{
                                        color: "var(--colorAccent)",
                                        marginTop: "0",
                                        marginBottom: "4px"
                                    }}
                                >
                                    {item.title}
                                </h4>
                            )}
                            {item.para1 && (
                                <p
                                    className="event-description"
                                    style={{
                                        marginTop: "0"
                                    }}
                                >
                                    {item.para1}
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            {!isLoading && !error && circulars.length === 0 && (
                <p className="no-events">No circulars available</p>
            )}
        </div>
    );
};

export default CircularsContent;